var React = require('react');

function DropdownArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".dropdown-arrow-1{fill:#fff;stroke:#d6d8d2;stroke-linecap:round;stroke-miterlimit:10;stroke-width:0.7px;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("polyline",{"className":"dropdown-arrow-1","points":"0.35 0.48 10.55 8.91 19.93 0.35"})))]);
}

DropdownArrow.defaultProps = {"viewBox":"0 0 20.28 9.38"};

module.exports = DropdownArrow;

DropdownArrow.default = DropdownArrow;
